import { z } from 'zod';

/**
 * 表示の切り替え。`table` は全行スプレッドシート、`profile` は 1 名ずつの項目カード。
 * 既定は全体を見渡せる `table`。
 */
export const PayrollEventEditViewModeSchema = z.enum(['table', 'profile']).default('table').catch('table');
export type PayrollEventEditViewMode = z.infer<typeof PayrollEventEditViewModeSchema>;
export const SearchSchema = z.object({
  /** 修正対象のデータのバージョン（Task ID）。未指定なら最新バージョンを修正する。 */
  versionId: z.string().optional(),
  /** 不正値でもエラー画面に落とさず既定表示に戻す */
  view: PayrollEventEditViewModeSchema
});